import {
  interactions
} from '../constants';

/**
 * Import constants
 */
const {
  SAVE_INTERACTIONS,
  SET_WHOLE_INTERACTIONS
} = interactions;

/**
 * Action creators
 */
const actions = {
  saveInteractions: (data) => ({ type: SAVE_INTERACTIONS, data }),
  setWhole: (data) => ({ type: SET_WHOLE_INTERACTIONS, data })
};

/**
 * Save interactions data
 */
export const saveInteractions = (data) => (dispatch) => dispatch(actions.saveInteractions(data));

/**
 * Set whole interaction data
 */
export const setWhole = (data) => (dispatch) => dispatch(actions.setWhole(data));
